import {
  useLoaders,
  useTableColumnsProducto,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  SearchComponente,
  GeneralTable,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { IDataProducto } from "@/shared/interfaces";
import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { useFetchProductos } from "@/shared/actions/erp";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AddIcon from "@mui/icons-material/Add";

interface ModalEquiposAdicionalesVentaProps {
  onChange: (e: IDataProducto) => void;
  iconButton?: boolean;
  textButton?: string;
  onlyShow?: boolean;
}

export default function ModalEquiposAdicionalesVenta({
  iconButton = false,
  onChange,
  textButton = "Agregar Item",
  onlyShow = false
}: ModalEquiposAdicionalesVentaProps) {
  ///* State
  const [openModalProducto, setOpenModalProducto] = useState<boolean>(false);
  const { columnsEquipoAdicional } = useTableColumnsProducto();
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isloadingProducto,
    data: productoRes,
    isRefetching: isRefetchingProducto
  } = useFetchProductos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      descripcion: searchTerm.toUpperCase(),
      es_para_venta: true,
      estado: true,
      filterByState: false,
      ...filterObject,
    }
  });

  useLoaders(isloadingProducto);

  return (
    <>
      {
        onlyShow?null:
        iconButton ? (
          <Tooltip placement="top" title="Todos los inventariables">
            <IconButton onClick={() => setOpenModalProducto(true)} size="medium">
              <ManageSearchIcon />
            </IconButton>
          </Tooltip>
          ) : (
          <Button
            startIcon={ <AddIcon />}
            variant="outlined"
            onClick={() => {
              setOpenModalProducto(true);
            }}
          >
              {textButton}
          </Button>
        )
      }

      {openModalProducto && (
        <ScrollableDialogProps
          open={openModalProducto}
          title="Seleccionar"
          //cancelTextBtn="Cerrar"
          onCloseIcon={() => {
            setOpenModalProducto(false);
          }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SearchComponente
                  onChange={onChangeFilter}
                  value={globalFilter}
                  text="por descripción inventariable." />
              </Grid>
              
              <Grid item xs={12}>
                <GeneralTable<IDataProducto>
                  columns={columnsEquipoAdicional}
                  data={productoRes?.data.data || []}
                  isLoading={isloadingProducto}
                  isRefetching={isRefetchingProducto}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={productoRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    onChange(e);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}

                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}

                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
